import { useRef } from "react";

/**
 * A role-switch button stays clickable until the next render sets `disabled`.
 * This latch drops that second click so only one grant is sent.
 */
export function useRoleSwitchInFlight() {
  const inFlight = useRef(false);

  const tryBegin = (): boolean => {
    if (inFlight.current) return false;
    inFlight.current = true;
    return true;
  };

  const end = (): void => {
    inFlight.current = false;
  };

  return { tryBegin, end };
}
